"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntryCard = exports.EntryCardComponent = exports.EntryCardDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var card_1 = require("../elements/card");
var content_1 = require("../elements/content");
var challenge_label_1 = require("./challenge-label");
var format_date_string_1 = require("../../utils/format-date-string");
var use_icons_1 = require("../../hooks/use-icons");
var truncate_words_1 = require("../../utils/truncate-words");
var icon_label_1 = require("../elements/icon-label");
var entity_image_1 = require("./entity-image");
var entity_cell_header_1 = require("./entity-cell-header");
var lodash_1 = require("lodash");
var entity_list_1 = require("./entity-list");
var entity_taxonomy_card_values_1 = require("./entity-taxonomy-card-values");
exports.EntryCardDefaultProps = {
  usePublishedField: false
};
// -------- Styles -------->
var CardStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    margin-bottom: ", ";\n  "], ["\n    display: flex;\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var ContentStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-grow: 1;\n    margin-top: ", ";\n    margin-bottom: ", ";\n    padding-top: ", ";\n    ", ";\n    \n  "], ["\n    flex-grow: 1;\n    margin-top: ", ";\n    margin-bottom: ", ";\n    padding-top: ", ";\n    ", ";\n    \n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3), theme_1.theme.H_DOT_BG())
});
var SitesStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", ";\n    margin-top: ", ";\n    padding-top: ", ";\n    color: ", ";\n  "], ["\n    ", ";\n    margin-top: ", ";\n    padding-top: ", ";\n    color: ", ";\n  "])), theme_1.theme.H_DOT_BG(), theme_1.theme.UNIT(3), theme_1.theme.UNIT(4), theme_1.theme.COLOR('dark'))
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: 500;\n    line-height: 1.25em;\n\n    &:hover {\n      color: ", ";\n    }\n  "], ["\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: 500;\n    line-height: 1.25em;\n\n    &:hover {\n      color: ", ";\n    }\n  "])), theme_1.theme.FONT('sans'), theme_1.theme.FONT_SIZE(18), theme_1.theme.COLOR('link-hover'))
});
var ImageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ChallengeLabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    text-shadow: 0px 1px 0px rgba(0,0,0,0.5);\n  "], ["\n    text-shadow: 0px 1px 0px rgba(0,0,0,0.5);\n  "])))
});
var OverlayStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: flex;\n    flex-grow: 1;\n    align-items: center;\n    justify-content: space-between;\n  "], ["\n    display: flex;\n    flex-grow: 1;\n    align-items: center;\n    justify-content: space-between;\n  "])))
});
var OverlayControlsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    > * {\n      margin-left: ", ";\n    }\n  "], ["\n    > * {\n      margin-left: ", ";\n    }\n  "])), theme_1.theme.UNIT(3))
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme_1.theme.UNIT(2))
});
var IconLabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), LabelStyles)
});
var HeaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(1))
});
var TaxonomiesStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Card: (0, styled_components_1.default)(card_1.Card)(templateObject_13 || (templateObject_13 = __makeTemplateObject([""], [""]))),
  Image: (0, styled_components_1.default)(entity_image_1.EntityImage)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  Content: (0, styled_components_1.default)(content_1.Content)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Title: styled_components_1.default.span(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Header: (0, styled_components_1.default)(entity_cell_header_1.EntityCellHeader)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  IconLabel: (0, styled_components_1.default)(icon_label_1.IconLabel)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), IconLabelStyles),
  ChallengeLabel: (0, styled_components_1.default)(challenge_label_1.ChallengeLabel)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), ChallengeLabelStyles),
  Overlay: styled_components_1.default.div(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), OverlayStyles),
  Sites: (0, styled_components_1.default)(entity_list_1.EntityList)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), SitesStyles),
  Taxonomies: (0, styled_components_1.default)(entity_taxonomy_card_values_1.EntityTaxonomyCardValues)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), TaxonomiesStyles),
  OverlayControls: styled_components_1.default.div(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), OverlayControlsStyles)
};
My.Card = (0, styled_components_1.default)(card_1.Card)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n  ", "\n \n  &:hover {\n    filter: brightness(110%);\n  }\n"], ["\n  ", "\n \n  &:hover {\n    filter: brightness(110%);\n  }\n"])), CardStyles);
var EntryCardComponent = function (props) {
  var className = props.className,
    entity = props.entity,
    border = props.border,
    path = props.path,
    usePublishedField = props.usePublishedField;
  var image = entity.image;
  var to = path;
  var href = '';
  var Icons = (0, use_icons_1.useIcons)();
  var sites = (0, lodash_1.get)(entity, 'sites', []);
  var hasSites = !!sites.length;
  var dateToDisplay = usePublishedField ? (entity === null || entity === void 0 ? void 0 : entity.published) || entity.created : entity.created;
  return React.createElement(My.Card, __assign({}, props, {
    space: 4,
    border: border,
    to: to,
    href: href,
    className: className,
    title: React.createElement(My.Title, null, entity.name),
    image: React.createElement(My.Image, {
      defaultImage: image,
      entity: entity,
      aspectRatio: {
        base: 21 / 9,
        tablet: 16 / 9
      },
      overlay: entity.challenge && React.createElement(My.Overlay, null, React.createElement(My.ChallengeLabel, {
        color: "light",
        entity: entity.challenge
      }))
    })
  }), React.createElement(My.Header, {
    entity: entity
  }), dateToDisplay && React.createElement(My.IconLabel, {
    icon: React.createElement(Icons.BriefcaseCircle, null)
  }, (0, format_date_string_1.formatDateString)(dateToDisplay, 'MMMM Do, YYYY')), entity.author && React.createElement(My.IconLabel, {
    icon: React.createElement(Icons.PersonCircle, null)
  }, entity.author), hasSites && React.createElement(My.Sites, {
    variant: 'card',
    items: sites
  }), React.createElement(My.Taxonomies, {
    entity: entity
  }), React.createElement(My.Content, {
    tiny: true,
    html: entity.summary && entity.summary.text && (0, truncate_words_1.truncateWords)(entity.summary.text, {
      max: 60
    })
  }));
};
exports.EntryCardComponent = EntryCardComponent;
exports.EntryCardComponent.defaultProps = exports.EntryCardDefaultProps;
exports.EntryCard = React.memo(exports.EntryCardComponent);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24;